export default __webpack_public_path__ + "static/media/trick.06d78367.svg";